import styled from "styled-components";
import { yetAnotherDarkBlue } from "../../styles/colors";

const Header3 = styled.h1`
  color: ${yetAnotherDarkBlue};
  font-size: 1rem;
`;

export default Header3;
